import { PropTypes } from "prop-types";
import SwiperCore, { Navigation, Pagination, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.min.css";

import useDeviceDetect from "../../hooks/useDeviceDetect";

import IconArrowCircleMd from "../icons/svgs/arrow-circle-md.svg";
import IconStar from "../icons/svgs/star.svg";
import IconChecked from "../icons/svgs/check.svg";

import * as companyReviewsStyles from "./companyReviews/companyReviewsStyles.module.scss";
import "./companyReviews/companyReviews.scss";

function CompanyReviews({ content }) {
  SwiperCore.use([Navigation, Pagination, A11y]);
  const { isMobile } = useDeviceDetect();

  if (content) {
    return (
      <div
        className={`company_review_container ${companyReviewsStyles.container} id-${content.contentful_id}`}
        style={{ backgroundColor: content?.backgroundColor || "#f8f5f1" }}
      >
        <div className="company_review_header">
          <h2
            className={`${companyReviewsStyles.container_title} h2 h2--bold h2--uc`}
            style={{
              color: isMobile
                ? content?.titleColor?.mobile || "#FFF"
                : content?.titleColor?.desktop || "FFF",
            }}
          >
            {content.title}
          </h2>
          <div className="swiper_action_buttons">
            <div className="swiper_prev_review_button">
              <IconArrowCircleMd width="32" stroke="#2D2927" />
            </div>
            <div className="swiper_next_review_button">
              <IconArrowCircleMd width="32" stroke="#2D2927" />
            </div>
          </div>
        </div>
        <div className={`${companyReviewsStyles.container_desktop} company_review_content`}>
          <Swiper
            navigation={{
              nextEl: ".swiper_next_review_button",
              prevEl: ".swiper_prev_review_button",
              disabledClass: "swiper_disabled_button_reviews",
            }}
            pagination={{
              clickable: true,
              el: ".swiper_pagination",
              renderBullet: (index, className) => `<span class="${className}">&nbsp;</span>`,
            }}
            spaceBetween={20}
            slidesPerView={3}
            slidesPerGroup={3}
          >
            {content.reviews.map((r, i) => (
              <SwiperSlide key={`home_review_${i}`}>
                <div
                  className={`${companyReviewsStyles.content_review}`}
                  style={{ backgroundColor: r?.backgroundColor || "#FFF" }}
                >
                  <div>
                    <span className={companyReviewsStyles.content_review_stars}>
                      {Array.apply(null, Array(5)).map((x, i) =>
                        r.stars - 1 >= i ? (
                          <IconStar
                            width={isMobile ? "16" : "20"}
                            fill="#2D2927"
                            stroke="#2D2927"
                            key={`home_review_${i}_icon_${i}`}
                          />
                        ) : (
                          <IconStar
                            width={isMobile ? "16" : "20"}
                            key={`home_review_${i}_icon_${i}`}
                          />
                        )
                      )}
                    </span>
                    <p className={`${companyReviewsStyles.content_review_content} text`}>
                      {r.content.content}
                    </p>
                  </div>
                  <div className={companyReviewsStyles.content_review_author}>
                    <p
                      className={`${companyReviewsStyles.content_review_author_name} subtext subtext--bold`}
                    >
                      {r.name}
                    </p>
                    <p className={`${companyReviewsStyles.content_review_author_icon} text`}>
                      <IconChecked width="14" height="14" />
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div
          className={`${companyReviewsStyles.content_reviews} ${companyReviewsStyles.container_mobile}`}
        >
          {content.reviews.map((r, i) => (
            <div className={companyReviewsStyles.content_review} key={`home_review_${i}`}>
              <div>
                <span className={companyReviewsStyles.content_review_stars}>
                  {Array.apply(null, Array(5)).map((x, i) =>
                    r.stars - 1 >= i ? (
                      <IconStar
                        width={isMobile ? "16" : "20"}
                        fill="#2D2927"
                        stroke="#2D2927"
                        key={`home_review_${i}_icon_${i}`}
                      />
                    ) : (
                      <IconStar width={isMobile ? "16" : "20"} key={`home_review_${i}_icon_${i}`} />
                    )
                  )}
                </span>
                <p className={`${companyReviewsStyles.content_review_content} text`}>
                  {r.content.content}
                </p>
              </div>
              <div className={companyReviewsStyles.content_review_author}>
                <p
                  className={`${companyReviewsStyles.content_review_author_name} subtext subtext--bold`}
                >
                  {r.name}
                </p>
                <p className={`${companyReviewsStyles.content_review_author_icon} text`}>
                  <IconChecked width="14" height="14" />
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
}

CompanyReviews.propTypes = {
  content: PropTypes.shape({
    contentful_id: PropTypes.string,
    title: PropTypes.string,
    backgroundColor: PropTypes.string,
    reviews: PropTypes.arrayOf(PropTypes.any),
  }),
};

export default withALErrorBoundary({
  name: "CompanyReviews",
  priority: "P2",
})(CompanyReviews);
